var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"routes-locator flex gap10 wrap"},[_vm._l((_vm.links),function(link,idx){return [_c('router-link',{key:'link_'+idx,attrs:{"disabled":link.disabled,"to":link.to}},[_vm._v(_vm._s(link.label))]),(idx !== _vm.links.length-1)?_c('span',{key:'span_'+idx},[_vm._v(" > ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }